import React from "react";

import { ConfigProvider, FloatButton } from "antd";

export default function FloatButtonComp(props) {
  const { icon, tooltip, theme, onClick, buttonKey, isDisabled } = props;

  const renderIcon = () => {
    if (!icon) return null;

    // Check if icon is a URL string (for <img>) or a React component
    if (typeof icon === "string") {
      return (
        <img
          src={icon}
          alt="button icon"
          style={{
            width: "20px",
            height: "20px",
            filter: `${
              isDisabled ? "brightness(0)" : "brightness(0) invert(1)"
            }`,
          }}
        />
      );
    }

    // If icon is a React component render it directly
    return React.createElement(icon, {
      style: { width: "1em", height: "1em" },
    });
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimaryHover: "#381B36",
          colorPrimary: "#92428B",
          //   colorBgElevated: "red"
        },
      }}
    >
      {/* <div> */}
      <FloatButton
        icon={renderIcon()}
        tooltip={`${isDisabled ? `${tooltip} action not allowed` : tooltip}`}
        //  <div>Cannot perform {tooltip} action </div>}
        type={theme}
        onClick={onClick}
        key={buttonKey}
        disabled={isDisabled}
        style={isDisabled ? btnStyle.disable : btnStyle.enable}
      />
      {/* </div> */}
    </ConfigProvider>
  );
}

const btnStyle = {
  disable: {
    cursor: "not-allowed",
    opacity: 0.5,
    color: "#d9d9d9",
  },
  enable: {
    cursor: "pointer",
    opacity: 1,
    color: "#595959",
  },
};
